import React from 'react'
import PropTypes from 'prop-types'

function EconomyCard ({ children }) {
  return (
    <div className='group space-y-4 bg-white rounded-lg border border-gray-200 px-4 py-5 overflow-hidden'>
      {children}
    </div>
  )
}

export default EconomyCard
